import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default class GHeader {
	constructor(el) {
		el = el || document.querySelector('#gheader')
		if (!el) return

		this.r = el
		this.n = el.querySelector('nav')
		this.t = el.querySelector('.toggle')
		this.anchors = this.n.querySelectorAll('a')

		if (this.t) this.t.onclick = this.toggle.bind(this)
		if (innerWidth > 767) return

		const pathname = location.pathname
		const length = this.anchors.length
		
		for (let i = 0; i < length; i++) {
			const href = this.anchors[i].getAttribute('href')

			if (href == null) continue

			const newHref = href.replace(pathname, '')
			const isHash = newHref[0] === '#'

			if (!isHash) continue

			this.anchors[i].addEventListener('click', this.close.bind(this))
		}
	}

	toggle() {
		if (this.t.getAttribute('aria-expanded') === 'false') this.open()
		else this.close()
	}

	open() {
		const height = innerHeight - this.r.offsetHeight
		this.n.style.height = height + 'px'
		this.n.style.overflowY = "auto"
		this.t.setAttribute('aria-expanded', 'true')
		document.documentElement.style.overflow = 'hidden'
		disableBodyScroll(this.r)
	}

	close() {
		this.n.style.height = null
		this.n.style.overflowY = null
		this.t.setAttribute('aria-expanded', 'false')
		document.documentElement.style.overflow = null
		enableBodyScroll(this.r)
	}
}
